import { render } from "./TrailerForm.vue?vue&type=template&id=5c816e93&scoped=true"
import script from "./TrailerForm.vue?vue&type=script&lang=js"
export * from "./TrailerForm.vue?vue&type=script&lang=js"

import "./TrailerForm.vue?vue&type=style&index=0&id=5c816e93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c816e93"]])

export default __exports__